/**
 * Bluedot Redux Constants
 *
 * Action types and state keys for Bluedot integration.
 */

export const BLUEDOT_INITIALIZE = "bluedot/INITIALIZE";
export const BLUEDOT_INITIALIZE_SUCCESS = "bluedot/INITIALIZE_SUCCESS";
export const BLUEDOT_INITIALIZE_FAILURE = "bluedot/INITIALIZE_FAILURE";

export const BLUEDOT_LOCATION_ENABLE = "bluedot/LOCATION_ENABLE";
export const BLUEDOT_LOCATION_ENABLED = "bluedot/LOCATION_ENABLED";
export const BLUEDOT_LOCATION_FAILURE = "bluedot/LOCATION_FAILURE";

export const BLUEDOT_WAVE_SEND = "bluedot/WAVE_SEND";
export const BLUEDOT_WAVE_SENT = "bluedot/WAVE_SENT";
export const BLUEDOT_WAVE_FAILURE = "bluedot/WAVE_FAILURE";

export const BLUEDOT_RESET = "bluedot/RESET";
export const BLUEDOT_ERROR = "bluedot/ERROR";

// Native permission tracking
export const BLUEDOT_NATIVE_PERMISSION_CHECK =
  "bluedot/NATIVE_PERMISSION_CHECK";
export const BLUEDOT_NATIVE_PERMISSION_GRANTED =
  "bluedot/NATIVE_PERMISSION_GRANTED";
export const BLUEDOT_NATIVE_PERMISSION_DENIED =
  "bluedot/NATIVE_PERMISSION_DENIED";

// Initial state keys
export const BLUEDOT_STATE_KEYS = {
  ENABLED: "enabled",
  INITIALIZED: "initialized",
  INITIALIZING: "initializing",
  LOCATION_ENABLED: "locationEnabled",
  LOCATION_REQUESTING: "locationRequesting",
  NATIVE_PERMISSION_GRANTED: "nativePermissionGranted",
  NATIVE_PERMISSION_CHECKED: "nativePermissionChecked",
  NATIVE_PERMISSION_STATUS: "nativePermissionStatus",
  WAVE_SENDING: "waveSending",
  LAST_WAVE: "lastWave",
  ERROR: "error"
};
